import { Node } from "#/decision_tree_viewer/models/node";

export class DenyNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "DenyNode",

      step: false,

      title: undefined,
      message: undefined,
    };
  }
}
